import { API } from "aws-amplify";
import axios from 'axios';
import "containers/common/List.css";
import Moment from "moment";
import React, { Component } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import { PacmanLoader } from 'react-spinners';


const CancelToken = axios.CancelToken;
const source = CancelToken.source();

export default class AsicSearchQueue extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            asicSearches: [],
            filter: {},
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false,
            agentName: "",
            searchOnOption: "next_search",
            selectedSearchOnOption: {value: "next_search", label: "Next Search"},
            lastSearchDate: new Date(),
            lastSearchOperator: "lessthan",
            selectedLastSearchOperator: {value: "lessthan", label: "less than"},
            nextSearchDate: new Date(),
            nextSearchOperator: "lessthan",
            selectedNextSearchOperator: {value: "lessthan", label: "less than"},
            selectedCityscope: null,
            cityscopeOptions: [],
            cityscope: null,
            operatorOptions: [{value: "lessthan", label: "less than"},{value: "greaterthan", label: "greater than"},{value: "equal", label: "equal"}],
            searchOnOptions: [{value: "next_search", label: "Next Search"}, {value: "last_search", label: "Last Search"}],
            rowCount: 0
        };

        
    }
    

    async componentDidMount() {
        console.log("In AgentList componentDidMount");
        this.setState({ isLoading: true });      
        if (!this.props.isAuthenticated) { // if false
            return;
        }

        const asicSearches = await this.getAsicSearches({cityscope: this.state.cityscope
            , nextsearchoperator: this.state.nextSearchOperator
            , datenextsearch: this.state.nextSearchDate!==null ? Moment(this.state.nextSearchDate).local().format(): null
            , lastsearchoperator: this.state.lastSearchOperator
            , datelastsearch: this.state.lastSearchDate !== null? Moment(this.state.lastSearchDate).local().format(): null
            });
        this.setState({ asicSearches });
        
        this.getCityscopes();

        document.title = "ASIC Search Queue";
        this.setState({ isLoading: false });      
    }

    
    componentWillUnmount() {
        source.cancel();
        
        
        this.setState({ agents: [] });        
    }

    async getAsicSearches(filter) {
        console.log("Inside getAsicSearches() ");
        
        return API.get("colin", "/queues/asicsearches", { 'queryStringParameters': filter, 'cancelToken': source.token });
      
    }

    
    async getCityscopes() {
        try {
            API.get("colin", `/cityscopes/dropdown`, { 'cancelToken': source.token }).then((cityscopeOptions) => {
                if (cityscopeOptions) {
                    this.setState(state => ({ cityscopeOptions }));
                }
            });
        }
        catch{
            console.log("Error getting cityscopes");
        }
    }    



    handleCityscopeChange = async (selectedCityscope) => {
        
        this.setState({ selectedCityscope
                        ,cityscope: selectedCityscope.value 
                        , modified: true },this.handleBlur)
        

    }

    handleSearchOnOptionChange = async (selectedSearchOnOption) => {
        this.setState({ selectedSearchOnOption ,searchOnOption: selectedSearchOnOption.value, modified: true });
        const selected = selectedSearchOnOption.value;
        this.setState({
            lastSearchDate: (selected === 'last_search') ? new Date() : null,
            lastSearchOperator: (selected === 'last_search') ? 'lessthan' : null,
            selectedLastSearchOperator: (selected === 'last_search') ? {value: "lessthan", label: "less than"} : null,
            nextSearchDate:  (selected === 'next_search') ? new Date() : null,
            nextSearchOperator: (selected === 'next_search') ? 'lessthan' : null,
            selectedNextSearchOperator: (selected === 'next_search') ? {value: "lessthan", label: "less than"} : null,
        });
    };

    handleNextSearchOperatorChange = async (selectedNextSearchOperator) => {
        
        this.setState({ selectedNextSearchOperator
                        ,nextSearchOperator: selectedNextSearchOperator.value 
                        , modified: true },this.handleBlur)        
    }

    handleLastSearchOperatorChange = async (selectedLastSearchOperator) => {
        
        this.setState({ selectedLastSearchOperator
                        ,lastSearchOperator: selectedLastSearchOperator.value 
                        , modified: true },this.handleBlur)        
    }
   

    handleSubmit = async event =>{
        event.preventDefault();
        try {
            this.setState({isLoading: true});

            const filterOptions = {
                last_search: {
                    lastsearchoperator: this.state.lastSearchOperator,
                    datelastsearch: this.state.lastSearchDate !== null ? Moment(this.state.lastSearchDate).format('YYYY-MM-DD') : null
                },
                next_search: {
                    nextsearchoperator: this.state.nextSearchOperator,
                    datenextsearch: this.state.nextSearchDate !== null ? Moment(this.state.nextSearchDate).format('YYYY-MM-DD') : null
                }
            }
            const asicSearches = await this.getAsicSearches({cityscope: this.state.cityscope, ...filterOptions[this.state.searchOnOption]});
            const flattenedSearches = asicSearches.flat();
            this.setState({ asicSearches});
            this.setState({isLoading: false});
            this.setState({ rowCount: flattenedSearches.length})
        } catch (e) {
            alert(e);
        }
    }
    
    
    renderPacman(){
        return (
            <div className="outer-div"><div className='sweet-loading inner-div' >
                <PacmanLoader
                    css="display: block;
                    margin: 0 auto;
                     border-color: red"
                sizeUnit={"px"}
                size={20}
                color={'#e03c31'}
                loading={this.state.isLoading}
                />
        </div>
            </div>);
    }
      
    
    renderTable(data) {
        const formatter = new Intl.NumberFormat('en-AU', {
            style: 'currency',
            currency: 'AUD',
            minimumFractionDigits: 0,
            currencyDisplay: "symbol"
        })

        const columns = [

            {
                id: 'owner_id',
                Header: 'Owner ID',
                maxWidth: 150,
                accessor: 'owner_id' ,
                Cell: e => <a target="_blank" href={`/owners/${e.value}`} >{e.value}</a>
        }
        , {
                id: 'owner_name',
                Header: 'Name',            
                accessor: 'owner_name',
                maxWidth: 250
                

            }, {
                id: 'acn',
                Header: 'ACN',            
                accessor: 'acn',
                maxWidth: 150

            }
            ,
            {
                id: 'search_notes',
                Header: 'Search Notes',            
                accessor: 'search_notes',
                maxWidth: 150

            },
            {
                id: 'dir_name_1',
                Header: 'Director 1',            
                accessor: 'dir_name_1',
                maxWidth: 150

            },
            {
                id: 'dir_name_2',
                Header: 'Director 2',            
                accessor: 'dir_name_2',
                maxWidth: 150

            }
            ,
            {
                id: 'date_last_search',
                Header: 'Date Last Searched',
                maxWidth: 150,
                style: { textAlign: "center" },
                accessor: d => d.date_last_search ? new Date(d.date_last_search) : null,
                Cell: ({ value}) => value ? Moment(value).local().format("DD-MM-YYYY") : null
                // accessor: d => {
                //     if (d.date_last_search) {
                //         return Moment(d.date_last_search)
                //             .local()
                //             .format("DD-MM-YYYY")
                //     }
                //     else { return null }
                // }
            },
                {
                    id: 'date_next_search',
                    Header: 'Date Next Search',
                    maxWidth: 150,
                    style: { textAlign: "center" },
                    accessor: d => d.date_next_search ? new Date(d.date_next_search) : null,
                    Cell: ({ value}) => value ? Moment(value).local().format("DD-MM-YYYY") : null
                    // accessor: d => {
                    //     if (d.date_next_search) {
                    //         return Moment(d.date_next_search)
                    //             .local()
                    //             .format("DD-MM-YYYY")
                    //     }
                    //     else { return null }
                    // }

            },
            {
                id: 'direct_owned',
                Header: 'Direct Owned',
                maxWidth: 100,
                accessor: d => {
                                if (d.property_list) {
                                    return d.property_list.filter(r=> r.owner_type==="Direct").length
                                }
                                else { return null }
                            }

        },
        {
            id: 'sum_direct_owned',
            Header: 'Direct Owned $ Value',
            maxWidth: 100,
            accessor: d => {
                if (d.property_list){
                    const rawValue = d.property_list
                        .filter(r => r.owner_type === "Direct")
                        .map(r => parseFloat((r.sale_price || "0").replace(/[^0-9.-]+/g,"")))
                        .reduce((a,b) => a + b, 0);
                    return rawValue;
                } else {
                    return null;
                }
            },
            Cell: ({ value }) => {
                return formatter.format(value)
            }
            // accessor: d => {
            //                 if (d.property_list) {
            //                     return formatter.format(d.property_list.filter(r=> r.owner_type==="Direct").map( r=>parseFloat((r.sale_price||"0").replace(/[^0-9.-]+/g,"")) ).reduce((a,b)=> a+b,0))
            //                 }
            //                 else { return null }
            //             }

    },
        {
            id: 'indirect_owned',
            Header: 'Indirect Owned',
            maxWidth: 100,
            accessor: d => {
                            if (d.property_list) {
                                return d.property_list.filter(r=> r.owner_type==="Indirect").length
                            }
                            else { return null }
                        }

    },
    {
        id: 'sum_indirect_owned',
        Header: 'Indirect Owned $ Value',
        maxWidth: 100,
        accessor: d => {
                        if (d.property_list) {
                            return formatter.format(d.property_list.filter(r=> r.owner_type==="Indirect").map( r=>parseFloat((r.sale_price||"0").replace(/[^0-9.-]+/g,"")) ).reduce((a,b)=> a+b,0))
                        }
                        else { return null }
                    }

}

        ]          

        if (!data) {
            return null
        }
        else {
            
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={30}
                    sortable={true}
                    className="-striped -highlight"
                    SubComponent={row => {
                        return (
                          <div style={{ padding: "20px" }}>
                              
                            <br />
                            <ReactTable
                              data={row.original.property_list}
                              columns={[{
                                            id: 'property_key',
                                            Header: 'Cityscope Ref',            
                                            accessor: 'property_key',
                                            maxWidth: 100,
                                            Cell: e => <a target="_blank" rel="noopener noreferrer" href={`../properties/${e.value}`} >{e.value}</a>
                                        },
                                        {
                                            id: 'classification',
                                            Header: 'Classification',            
                                            accessor: 'classification',
                                            maxWidth: 250
                                        },
                                        {
                                            id: 'owner_type',
                                            Header: 'Owner Type',            
                                            accessor: 'owner_type',
                                            maxWidth: 250
                                        },
                                        {
                                            id: 'area',
                                            Header: 'Area',            
                                            accessor: 'area',
                                            maxWidth: 250
                                        },
                                        {
                                            id: 'sale_price',
                                            Header: 'Sale Price',            
                                            accessor: 'sale_price',
                                            maxWidth: 250
                                        }
                                        ]}
                              defaultPageSize={5}
                              showPagination={true}

                            />
                          </div>
                        );
                      }}
                />
            )
        }
    }

    handleChange = event => {
        this.setState({
            [event.target.id]: event.target.value
        });
        this.setState({ modified: true });
    }

 
    handleNextDateChange = (date) =>{
        if (date) {
            this.setState({
                nextSearchDate: new Date(date)
                , modified: true },this.handleBlur);
        }
        else {
            this.setState({
                nextSearchDate: null
                , modified: true },this.handleBlur);
        }
        
    }

    handleLastDateChange = (date) =>{
        if (date) {
            this.setState({
                lastSearchDate: new Date(date)
                , modified: true },this.handleBlur);
        }
        else {
            this.setState({
                lastSearchDate: null
                , modified: true },this.handleBlur);
        }
        
    }
    
    renderComponent() {
        return (
            <div className="agents">
                <form onSubmit={this.handleSubmit}>
                 <Row >
                     <Col  sm={2} md={2} lg={1}>
                     <Form.Group controlId="state" >
                        <Form.Label className="text-right" >Cityscope</Form.Label>

                        <Select
                            value={this.state.selectedCityscope}
                            onChange={this.handleCityscopeChange}
                            options={this.state.cityscopeOptions}
                            onInputChange={this.handleInputChange}

                        />


                    </Form.Group>
                     </Col>

                    <Col sm={2} md={2} lg={1}>
                        <Form.Group controlId="state" >
                            <Form.Label className="text-right" >Search On</Form.Label>
                            <Select
                                value={this.state.selectedSearchOnOption}
                                onChange={this.handleSearchOnOptionChange}
                                options={this.state.searchOnOptions}
                                onInputChange={this.handleInputChange}
                            />
                        </Form.Group>
                    </Col>

                        { this.state.searchOnOption === 'next_search' &&
                            <React.Fragment>
                                <Col sm={4} md={4} lg={1}>                    
                                    <Form.Group  controlId="selectNextSearchOperator" >
                                        <Form.Label  >Search Type</Form.Label>
                                        <Select
                                            value={this.state.selectedNextSearchOperator}
                                            onChange={this.handleNextSearchOperatorChange}
                                            options={this.state.operatorOptions}
                                            onInputChange={this.handleInputChange}
                                        />
                                    </Form.Group>
                                    </Col >
                                    <Col sm={6} md={6} lg={2}> 
                                    <Form.Group   controlId="nextSearchDate" >
                                        <Form.Label>Search Date</Form.Label><br/>
                                            <DatePicker
                                                selected={this.state.nextSearchDate}
                                                onChange={this.handleNextDateChange}
                                                name="nextSearchDate"
                                                onBlur={this.handleSave}
                                                dateFormat="dd/MM/yyyy"
                                                className="form-control"
                                                isClearable={true}
                                            />
                                    </Form.Group>
                                </Col>
                            </React.Fragment>
                        }

                        { this.state.searchOnOption === 'last_search' &&

                            <React.Fragment>
                            <Col sm={4} md={4} lg={1}>                    
                            <Form.Group  controlId="selectLastSearchOperator" >
                                <Form.Label  >Search Type</Form.Label>
                                <Select
                                    value={this.state.selectedLastSearchOperator}
                                    onChange={this.handleLastSearchOperatorChange}
                                    options={this.state.operatorOptions}
                                    onInputChange={this.handleInputChange}
                                />
                            </Form.Group>
                            </Col > 
                            <Col sm={6} md={6} lg={2}> 
                            <Form.Group   controlId="lastSearchDate" >
                                <Form.Label>Search Date</Form.Label><br/>
                                    <DatePicker
                                        selected={this.state.lastSearchDate}
                                        onChange={this.handleLastDateChange}
                                        name="lastSearchDate"
                                        onBlur={this.handleSave}
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control"
                                        isClearable={true}
                                    />
                            </Form.Group>
                                </Col>
                            </React.Fragment>
                        }
                        
                        <Col>
                            <Button type="submit" variant="primary">Search</Button>
                        </Col>
                    </Row> 
                    </form>
                    {/* Total Rows Display */}
                    <div style={{
                        fontSize: "16px",
                        marginBottom: "10px",
                        color: this.state.rowCount === 1000 ? "red" : "black",
                        fontWeight: this.state.rowCount === 1000 ? "bold" : "normal",
                    }}>
                        Total Rows: {this.state.rowCount}
                    </div>
                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                     
                        {!this.state.isLoading ? this.renderTable(this.state.asicSearches) : this.renderPacman()  }
                        </Col>
                    </Row>
           

            </div>
        );
    }
  render() {
    return (

        <div className="AgentList">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            
        </div>
    );
  }
}
